import type { GroupDriverDto } from './GroupDriverDto'
import type { GroupMasterDto } from './GroupMasterDto'
import type { GroupTeacherDto } from './GroupTeacherDto'
import type { GroupTransportDto } from './GroupTransportDto'
import type { SchoolDto } from './SchoolDto'
import type { StudentDto } from './StudentDto'

export const groupDataDtoStatusEnum = {
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  '10': 10,
} as const

export type GroupDataDtoStatusEnum = (typeof groupDataDtoStatusEnum)[keyof typeof groupDataDtoStatusEnum]

export type GroupDataDto = {
  /**
   * @type number
   */
  status: GroupDataDtoStatusEnum
  /**
   * @type number
   */
  id: number
  /**
   * @type string
   */
  title: string
  /**
   * @type string, date-time
   */
  start_date: string
  /**
   * @type string, date-time
   */
  end_date: string
  /**
   * @type string
   */
  category_id: string
  /**
   * @type number
   */
  school_id: number
  school: SchoolDto | null
  /**
   * @type array
   */
  students: StudentDto[] | null
  /**
   * @type array
   */
  teacher: GroupTeacherDto[] | null
  /**
   * @type array
   */
  driver: GroupDriverDto[]
  /**
   * @type array
   */
  master: GroupMasterDto[] | null
  /**
   * @type array
   */
  transport: GroupTransportDto[] | null
}